<template>
  <main>
    <div v-if="currentUser" class="Objetivos">
      <headerFeed :currentUser="currentUser" title="Mis Objetivos"></headerFeed>
      <md-progress v-if="loading" class="md-accent" md-indeterminate></md-progress>
      <md-layout md-gutter class="contenidoPagina">
        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title">Vigente</h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="!acuerdoVigente && !loader">No tienes un acuerdo de objetivos aún. Pedile a tu lider que te genere uno.</p>
            <acuerdo @click.native="openDetail()" :showEditor="true" v-if="acuerdoVigente" :key="acuerdoVigente['.key']" :acuerdo="acuerdoVigente" :fluxer="acuerdoVigente.editor"></acuerdo>
          </main>
        </md-layout>

        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title">Archivados</h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="acuerdosArchivados.length === 0 && !loader">No tenés acuerdos de objetivos archivados aún.</p>
            <div v-for="acuerdo in acuerdosArchivados">
              <acuerdo @click.native="openDetail(acuerdo)" :showEditor="true" v-if="acuerdo.sent" :key="acuerdo['.key']" :acuerdo="acuerdo" :fluxer="acuerdo.editor"></acuerdo>
              <br>
            </div>
          </main>
        </md-layout>
      </md-layout>

      <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog-objetivos">
        <md-dialog-title>Seleccione a su lider</md-dialog-title>
        <md-dialog-content>
          <autocomplete v-model="liderSelected" :label="'Busca al lider aqui'" :array="allLideres" :debounce="1000"></autocomplete>
          <span v-show="error" class="md-error">El fluxer seleccionado es incorrecto, selecciona otro.</span>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button class="md-primary" @click="closeDialog('dialog-objetivos')">Cancelar</md-button>
            <md-button class="md-primary" @click="confirmDialog('dialog-objetivos')">Aceptar</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog md-open-from="#custom" md-close-to="#custom" ref="advertencia">
        <md-dialog-content>Ya tenes un acuerdo de objetivos previo, debe finalizarse el vigente para crear uno nuevo</md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="verVigente('advertencia')">Ver acuerdo vigente</md-button>
          <md-button class="md-primary" @click="closeDialog('advertencia')">Aceptar</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-alert
        :md-title="''"
        :md-content="'Hasta que tu lider no te envíe el acuerdo de objetivos no podras acceder al detalle.'"
        :md-ok-text="'Aceptar'"
        ref="advertenciaAcuerdo">
      </md-dialog-alert>
      <router-view></router-view>
    </div>
  </main>
</template>

<script>

import header from './Header'
import FluxerService from '../services/fluxer'
import ObjetivosService from '../services/objetivos'
import NotificationsService from '../services/notifications'
import Autocomplete from './Autocomplete'
import Acuerdo from './Acuerdo'
import Router from '../router'
import _ from 'lodash'

export default {
  name: 'mis-objetivos',
  components: {
    'headerFeed': header,
    'autocomplete': Autocomplete,
    'acuerdo': Acuerdo
  },
  data () {
    return {
      currentUser: FluxerService.getCurrentUser(),
      liderSelected: '',
      loading: false,
      loader: true,
      error: false
    }
  },
  computed: {
    acuerdoVigente: function () {
      return _.find(this.misAcuerdos, function (o) { return !o.finalizado })
    },
    acuerdosArchivados: function () {
      return _.filter(this.misAcuerdos, function (o) { return o.finalizado })
    }
  },
  firebase: function () {
    return {
      allLideres: FluxerService.getLideres(),
      misAcuerdos: {
        source: ObjetivosService.getByEmailOwner(this.currentUser.email),
        readyCallback: function () {
          this.loader = false
        }
      }
    }
  },
  methods: {
    openSelectFluxer (ref) {
      this.$refs[ref].open()
    },
    confirmDialog (ref) {
      let liderSelected = this.liderSelected
      let liderObjectSelect = _.find(this.allLideres, function (o) { return o.displayName === liderSelected })
      if (liderObjectSelect) {
        let currentUser = this.currentUser
        this.closeDialog(ref)
        this.loading = true
        ObjetivosService.createAcuerdo(liderObjectSelect.email, this.currentUser.email).then((resp) => {
          if (!resp.data.hayVigente) {
            NotificationsService.solicitarObjetivos(resp.data.acuerdoId, liderObjectSelect.email, currentUser)
          } else {
            this.$refs.advertencia.open()
          }
          this.loading = false
        })
      } else {
        this.error = true
      }
    },
    closeDialog (ref) {
      this.liderSelected = ''
      this.error = false
      this.$refs[ref].close()
    },
    verVigente (ref) {
      this.openDetail()
      this.closeDialog(ref)
    },
    openDetail (acuerdo) {
      if (!acuerdo) {
        acuerdo = this.acuerdoVigente
      }
      if (acuerdo.sent) {
        let lider = _.find(this.allLideres, function (o) { return o.email === acuerdo.editor })
        Router.push({name: 'mi-acuerdo-detail', params: {id: acuerdo['.key'], fluxerSelected: lider}})
      } else {
        this.$refs.advertenciaAcuerdo.open()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .set-objetivos {
        position: fixed !important;
        right: 10px;
        bottom: 10px;
        width: 56px !important;
        height: 56px !important;
        z-index: 10;
    }

    .md-error {
      color: red;
      top: -32px;
      position: inherit;
    }

  .contenidoPagina {
    padding-top: 64px;
  }
</style>



// WEBPACK FOOTER //
// MisObjetivos.vue?7955730e